module.exports = __webpack_public_path__ + "img/my-authorized-select.4a1fba00.svg";